import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HospitalNames } from '@shared/models/hospitalTypes.model';
import { UserService } from '@shared/services/user.service';
import { Profile } from '../../models/profile.model';

@Component({
  selector: 'app-import-profile-dialog',
  templateUrl: './import-profile-dialog.component.html',
  styleUrls: ['./import-profile-dialog.component.scss'],
  standalone: false,
})
export class ImportProfileDialogComponent implements OnInit {
  public profileType: string = '';

  public profile: Profile | undefined;

  public label = '';

  public isLoading: boolean = true;

  public hospitalNames: HospitalNames;

  constructor(
    public dialogRef: MatDialogRef<ImportProfileDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService
  ) {
    this.profileType = data.profileType;
    this.hospitalNames = this.userService.getHospitalNames();
  }

  ngOnInit() {
    if (this.profileType === 'Anesthésiste') {
      this.label = 'Anesthésiste/IADE';
    } else if (this.profileType === 'Chirurgien') {
      this.label = this.hospitalNames.surgeonsName;
    } else {
      this.label = 'Ibode/Ide/AS';
    }
  }

  profileChange(profile: Profile) {
    this.profile = profile;
  }

  close() {
    this.dialogRef.close({ status: false });
  }

  import() {
    this.dialogRef.close({ status: true, profile: this.profile });
  }

  onChildLoadingChange(isLoading: boolean) {
    this.isLoading = isLoading;
  }
}
